import { DoqFaceSvgProps } from '../types';

const DashboardBellySimple = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 96 96"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_5067_201015)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-dashboard-belly-simple">
        <circle cx="48" cy="48" r="48" fill="white" />
        <path d="M 72,96 A 48,48 0 0,1 24,96 L 48,48 Z" fill="black" />
      </mask>
      <circle
        cx="48.5"
        cy="48"
        r="48"
        fill="#8800FF"
        mask="url(#bottom-mask-dashboard-belly-simple)"
      />

      <mask
        id="mask0_5067_201015"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="97"
        height="96"
      >
        <circle cx="48.5" cy="48" r="48" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_5067_201015)">
        <rect x="24.5" y="36" width="48" height="60" fill="white" />
      </g>
      <path
        d="M43.0992 55.2004C44.4247 55.2004 45.4992 54.1259 45.4992 52.8004C45.4992 51.4749 44.4247 50.4004 43.0992 50.4004C41.7737 50.4004 40.6992 51.4749 40.6992 52.8004C40.6992 54.1259 41.7737 55.2004 43.0992 55.2004Z"
        fill="#2974C4"
      />
      <path
        d="M53.8992 55.2004C55.2247 55.2004 56.2992 54.1259 56.2992 52.8004C56.2992 51.4749 55.2247 50.4004 53.8992 50.4004C52.5737 50.4004 51.4992 51.4749 51.4992 52.8004C51.4992 54.1259 52.5737 55.2004 53.8992 55.2004Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.9912 53.1C46.8363 55.6112 44.7506 57.6 42.2004 57.6C39.5494 57.6 37.4004 55.451 37.4004 52.8C37.4004 50.149 39.5494 48 42.2004 48C44.6482 48 46.668 49.8322 46.9633 52.2H50.0375C50.3328 49.8322 52.3526 48 54.8004 48C57.4514 48 59.6004 50.149 59.6004 52.8C59.6004 55.451 57.4514 57.6 54.8004 57.6C52.2502 57.6 50.1645 55.6112 50.0096 53.1H46.9912ZM46.1004 52.8C46.1004 54.9539 44.3543 56.7 42.2004 56.7C40.0465 56.7 38.3004 54.9539 38.3004 52.8C38.3004 50.6461 40.0465 48.9 42.2004 48.9C44.3543 48.9 46.1004 50.6461 46.1004 52.8ZM54.8004 56.7C56.9543 56.7 58.7004 54.9539 58.7004 52.8C58.7004 50.6461 56.9543 48.9 54.8004 48.9C52.6465 48.9 50.9004 50.6461 50.9004 52.8C50.9004 54.9539 52.6465 56.7 54.8004 56.7Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M34.1012 69.5996C32.7757 69.5996 31.7012 70.6741 31.7012 71.9996V76.7996C31.7012 78.1251 32.7757 79.1996 34.1012 79.1996H38.9012C40.2267 79.1996 41.3012 78.1251 41.3012 76.7996V71.9996C41.3012 70.6741 40.2267 69.5996 38.9012 69.5996H34.1012Z"
          fill="#2974C4"
        />
        <path
          d="M46.1012 69.5996C44.7757 69.5996 43.7012 70.6741 43.7012 71.9996V76.7996C43.7012 78.1251 44.7757 79.1996 46.1012 79.1996H50.9012C52.2267 79.1996 53.3012 78.1251 53.3012 76.7996V71.9996C53.3012 70.6741 52.2267 69.5996 50.9012 69.5996H46.1012Z"
          fill="#2974C4"
        />
        <path
          d="M55.7012 71.9996C55.7012 70.6741 56.7757 69.5996 58.1012 69.5996H62.9012C64.2267 69.5996 65.3012 70.6741 65.3012 71.9996V76.7996C65.3012 78.1251 64.2267 79.1996 62.9012 79.1996H58.1012C56.7757 79.1996 55.7012 78.1251 55.7012 76.7996V71.9996Z"
          fill="#2974C4"
        />
        <path
          d="M34.1012 81.5996C32.7757 81.5996 31.7012 82.6741 31.7012 83.9996V88.7996C31.7012 90.1251 32.7757 91.1996 34.1012 91.1996H38.9012C40.2267 91.1996 41.3012 90.1251 41.3012 88.7996V83.9996C41.3012 82.6741 40.2267 81.5996 38.9012 81.5996H34.1012Z"
          fill="#2974C4"
        />
        <path
          d="M43.7012 83.9996C43.7012 82.6741 44.7757 81.5996 46.1012 81.5996H50.9012C52.2267 81.5996 53.3012 82.6741 53.3012 83.9996V88.7996C53.3012 90.1251 52.2267 91.1996 50.9012 91.1996H46.1012C44.7757 91.1996 43.7012 90.1251 43.7012 88.7996V83.9996Z"
          fill="#2974C4"
        />
        <path
          d="M58.1012 81.5996C56.7757 81.5996 55.7012 82.6741 55.7012 83.9996V88.7996C55.7012 90.1251 56.7757 91.1996 58.1012 91.1996H62.9012C64.2267 91.1996 65.3012 90.1251 65.3012 88.7996V83.9996C65.3012 82.6741 64.2267 81.5996 62.9012 81.5996H58.1012Z"
          fill="#2974C4"
        />
      </g>
      <path
        d="M45.5012 74.4004C45.5012 75.9634 46.6802 77.2504 48.2012 77.4004V71.4004C46.6802 71.5504 45.5012 72.8374 45.5012 74.4004Z"
        fill="white"
      />
      <path
        d="M48.8102 71.4004C50.2292 71.5414 51.3602 72.6754 51.5012 74.0974H48.8102V71.4004Z"
        fill="white"
      />
      <path
        d="M51.5012 74.7034C51.3602 76.1254 50.2322 77.2594 48.8102 77.4004V74.7034H51.5012Z"
        fill="white"
      />
      <path
        d="M63.2012 72.0004H62.0012V77.1004H63.2012V72.0004Z"
        fill="white"
      />
      <path
        d="M57.8012 73.5004H59.0012V77.1004H57.8012V73.5004Z"
        fill="white"
      />
      <path
        d="M59.9012 74.7004H61.1012V77.1004H59.9012V74.7004Z"
        fill="white"
      />
      <path
        d="M34.778 74.3428C34.5444 74.5412 34.1988 74.8132 33.7412 75.1588V75.6004H36.0596V75.106H34.6388C35.1124 74.7476 35.4644 74.4324 35.6948 74.1604C35.9252 73.8884 36.0404 73.6148 36.0404 73.3396C36.0404 73.1348 35.9876 72.9572 35.882 72.8068C35.7764 72.6564 35.6356 72.5428 35.4596 72.466C35.2836 72.3892 35.09 72.3508 34.8788 72.3508C34.6484 72.3508 34.4276 72.3956 34.2164 72.4852C34.0084 72.5716 33.8356 72.698 33.698 72.8644L34.0244 73.234C34.13 73.1124 34.2548 73.018 34.3988 72.9508C34.546 72.8836 34.7092 72.85 34.8884 72.85C35.0484 72.85 35.1844 72.8932 35.2964 72.9796C35.4116 73.0628 35.4692 73.1828 35.4692 73.3396C35.4692 73.49 35.4132 73.6452 35.3012 73.8052C35.1892 73.962 35.0148 74.1412 34.778 74.3428Z"
        fill="white"
      />
      <path
        d="M37.1671 75.0532C37.0071 74.9828 36.8759 74.8884 36.7735 74.77L36.4711 75.1396C36.5863 75.2932 36.7479 75.418 36.9559 75.514C37.1671 75.61 37.4087 75.658 37.6807 75.658C37.9239 75.658 38.1351 75.618 38.3143 75.538C38.4967 75.458 38.6375 75.3476 38.7367 75.2068C38.8359 75.066 38.8855 74.906 38.8855 74.7268C38.8855 74.5732 38.8471 74.4388 38.7703 74.3236C38.6935 74.2084 38.5975 74.1204 38.4823 74.0596C38.3671 73.9956 38.2535 73.9588 38.1415 73.9492C38.3271 73.9172 38.4887 73.8372 38.6263 73.7092C38.7671 73.578 38.8375 73.4132 38.8375 73.2148C38.8375 72.9492 38.7319 72.7396 38.5207 72.586C38.3095 72.4292 38.0295 72.3508 37.6807 72.3508C37.4279 72.3508 37.2023 72.3972 37.0039 72.49C36.8087 72.5796 36.6455 72.7012 36.5143 72.8548L36.8023 73.2052C37.0391 72.9684 37.3143 72.85 37.6279 72.85C37.8167 72.85 37.9719 72.89 38.0935 72.97C38.2151 73.0468 38.2759 73.1572 38.2759 73.3012C38.2759 73.442 38.2151 73.5476 38.0935 73.618C37.9751 73.6884 37.8167 73.7236 37.6183 73.7236C37.4103 73.7236 37.2871 73.722 37.2487 73.7188V74.2228C37.2807 74.2196 37.4039 74.218 37.6183 74.218C38.0919 74.218 38.3287 74.3684 38.3287 74.6692C38.3287 74.8196 38.2695 74.9396 38.1511 75.0292C38.0327 75.1156 37.8695 75.1588 37.6615 75.1588C37.4919 75.1588 37.3271 75.1236 37.1671 75.0532Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.8372 85.2004C45.7444 85.45 45.698 85.7172 45.698 86.002C45.698 86.2868 45.7444 86.5556 45.8372 86.8084C45.93 87.058 46.0724 87.2628 46.2644 87.4228C46.4564 87.5796 46.6948 87.658 46.9796 87.658C47.2644 87.658 47.5028 87.5796 47.6948 87.4228C47.8868 87.2628 48.0292 87.058 48.122 86.8084C48.2148 86.5556 48.2612 86.2868 48.2612 86.002C48.2612 85.7172 48.2148 85.45 48.122 85.2004C48.0292 84.9476 47.8868 84.7428 47.6948 84.586C47.5028 84.4292 47.2644 84.3508 46.9796 84.3508C46.6948 84.3508 46.4564 84.4292 46.2644 84.586C46.0724 84.7428 45.93 84.9476 45.8372 85.2004ZM47.5172 85.1764C47.6324 85.3908 47.69 85.666 47.69 86.002C47.69 86.338 47.6324 86.6148 47.5172 86.8324C47.402 87.05 47.2228 87.1588 46.9796 87.1588C46.7364 87.1588 46.5572 87.05 46.442 86.8324C46.3268 86.6148 46.2692 86.338 46.2692 86.002C46.2692 85.666 46.3252 85.3908 46.4372 85.1764C46.5524 84.9588 46.7332 84.85 46.9796 84.85C47.226 84.85 47.4052 84.9588 47.5172 85.1764Z"
        fill="white"
      />
      <path
        d="M48.5886 84.8932H50.2494L49.0398 87.6004H49.6542L50.8974 84.7876V84.3988H48.5886V84.8932Z"
        fill="white"
      />
      <path
        d="M60.2012 89.4004C58.6802 89.2504 57.5012 87.9634 57.5012 86.4004C57.5012 84.8374 58.6802 83.5504 60.2012 83.4004V89.4004Z"
        fill="white"
      />
      <path
        d="M60.8102 89.4004C62.2322 89.2594 63.3602 88.1254 63.5012 86.7034H60.8102V89.4004Z"
        fill="white"
      />
      <path
        d="M39.2012 85.8004C39.5312 85.8004 39.8012 85.5304 39.8012 85.2004C39.8012 84.8704 39.5312 84.6004 39.2012 84.6004C38.8712 84.6004 38.6012 84.8704 38.6012 85.2004C38.6012 85.2544 38.6072 85.3054 38.6222 85.3534L37.5572 86.4214C37.5092 86.4064 37.4552 86.4004 37.4012 86.4004C37.3472 86.4004 37.2932 86.4064 37.2452 86.4214L36.4802 85.6564C36.4952 85.6084 36.5012 85.5544 36.5012 85.5004C36.5012 85.1704 36.2312 84.9004 35.9012 84.9004C35.5712 84.9004 35.3012 85.1704 35.3012 85.5004C35.3012 85.5544 35.3072 85.6084 35.3222 85.6564L33.9542 87.0214C33.9062 87.0064 33.8552 87.0004 33.8012 87.0004C33.4712 87.0004 33.2012 87.2704 33.2012 87.6004C33.2012 87.9304 33.4712 88.2004 33.8012 88.2004C34.1312 88.2004 34.4012 87.9304 34.4012 87.6004C34.4012 87.5464 34.3952 87.4954 34.3802 87.4474L35.7452 86.0794C35.7932 86.0944 35.8472 86.1004 35.9012 86.1004C35.9552 86.1004 36.0092 86.0944 36.0572 86.0794L36.8222 86.8444C36.8072 86.8924 36.8012 86.9464 36.8012 87.0004C36.8012 87.3304 37.0712 87.6004 37.4012 87.6004C37.7312 87.6004 38.0012 87.3304 38.0012 87.0004C38.0012 86.9464 37.9952 86.8924 37.9802 86.8444L39.0482 85.7794C39.0962 85.7944 39.1472 85.8004 39.2012 85.8004Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2007 62.4C46.4241 62.4 44.8729 61.4348 44.043 60.0001L45.5174 60C46.1766 60.7365 47.1346 61.2 48.2007 61.2C49.2669 61.2 50.2249 60.7365 50.8841 60L52.3585 60.0001C51.5286 61.4348 49.9774 62.4 48.2007 62.4Z"
        fill="#2974C4"
      />
    </g>
    <defs>
      <clipPath id="clip0_5067_201015">
        <rect width="96" height="96" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export { DashboardBellySimple };
